const service = {
  msgArr: [],
  classArr: [],
  videoArr: [],
}
import {YDCLOUD} from '../../../tool/ydCloudCommon'

var roomsinfoString = localStorage.getItem('roomsinfo')
if (roomsinfoString == null){
  $.ajax({
    url: 'http://gjszbj-yd-huo.yd.com.cn/api/getRommsInfo',
    async: false,
    type: 'post',
    success: function (res){
      res = JSON.parse(res)
      localStorage.setItem('roomsinfo', JSON.stringify(res.data));
      roomsinfoString = JSON.stringify(res.data)
    }
  })
}
const roomsinfoObj = JSON.parse(roomsinfoString);
console.log(roomsinfoObj)
let node_name = '/zbj/zbjVolcano/' + roomsinfoObj.path + '/'

let ref1 = YDCLOUD.ref(node_name + 'chat')
// 互动数据
ref1.orderByKey().limitToLast(200).get(function (data) {
  for (let key in data.nodeContent) {
    service.msgArr.unshift(data.nodeContent[key]);
  }
})

ref1.on('child_add', function (data) {
  service.msgArr.unshift(data.nodeContent);
});

//节目单获取
let ref2 = YDCLOUD.ref(node_name + 'classes');
ref2.get(function (data) {
  service.classArr = data.nodeContent
});

ref2.on('value', function (data) {
  service.classArr = []
  service.classArr = data.nodeContent
});

export default service



// WEBPACK FOOTER //
// ./src/views/zb/js/getmsg.js